export enum ConnectedAccountActivityTransactionType {
    Dispute = 'dispute',
    DisputeReversal = 'dispute_reversal',
    DisputeLost = 'dispute_lost',
    Refund = 'refund',
    RefundReversal = 'refund_reversal',
    RefundFailure = 'refund_failure',
    PaymentReserveHold = 'payment_reserve_hold',
    PaymentReserveRelease = 'payment_reserve_release',
    Payout = 'payout',
    PayoutFailure = 'payout_failure',
    PayoutReversal = 'payout_reversal',
    ConversionSell = 'conversion_sell',
    ConversionBuy = 'conversion_buy',
    ConversionReversal = 'conversion_reversal',
    Deposit = 'deposit',
    Adjustment = 'adjustment',
    Fee = 'fee',
    DdCredit = 'dd_credit',
    DdDebit = 'dd_debit',
    DcCredit = 'dc_credit',
    DcDebit = 'dc_debit',
    Transfer = 'transfer',
    Payment = 'payment',
    IssuingAuthorisationHold = 'issuing_authorisation_hold',
    IssuingAuthorisationRelease = 'issuing_authorisation_release',
    IssuingCapture = 'issuing_capture',
    IssuingRefund = 'issuing_refund',
    Purchase = 'purchase',
}
